import {
    AfterContentInit,
    Component,
    ContentChildren,
    EventEmitter,
    Input,
    OnInit,
    Output,
    QueryList,
    TemplateRef,
} from '@angular/core';
import { HamCellDirective, HamHeaderCellDirective } from '../../directives';

@Component({
    selector: 'ham-table',
    template: `
        <table>
            <thead>
                <tr>
                    <th *ngFor="let header of headerTemplates; let i = index" [class]="columnClasses[i] || ''">
                        <ng-container *ngTemplateOutlet="header"></ng-container>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="let row of paginatedData; let i = index"
                    [class.selected]="row === selectedRow"
                    (click)="selectRow(row)"
                >
                    <td *ngFor="let cell of cellTemplates; let i = index" [class]="columnClasses[i] || ''">
                        <ng-container *ngTemplateOutlet="cell; context: { $implicit: row }"></ng-container>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="pagination-wrapper">
            <ham-pagination
                [currentPage]="currentPage"
                [pageSize]="pageSize"
                [totalItems]="dataSource.length"
                (pageChange)="onPageChange($event)"
            ></ham-pagination>
        </div>
    `,
    styleUrls: ['./table.component.scss'],
})
export class HamTableComponent implements AfterContentInit, OnInit {
    private _dataSource: any[] = [];

    @Input() columnClasses: string[] = [];

    @Input()
    set dataSource(value: any[]) {
        if (!value) return;

        this._dataSource = value;
        this.totalPages = Math.ceil(value.length / this.pageSize);
        this.updatePaginatedData();
    }
    get dataSource() {
        return this._dataSource;
    }

    @Input() pageSize: number = 5;
    @Input() alreadySelectedRow: any = null;
    @Output() rowSelected = new EventEmitter<any>();

    @ContentChildren(HamHeaderCellDirective, { read: TemplateRef }) headerTemplates!: QueryList<TemplateRef<any>>;
    @ContentChildren(HamCellDirective, { read: TemplateRef }) cellTemplates!: QueryList<TemplateRef<any>>;

    currentPage: number = 1;
    totalPages: number = 1;
    paginatedData: any[] = [];
    selectedRow: any = null;

    ngAfterContentInit() {
        this.totalPages = Math.ceil(this.dataSource.length / this.pageSize);
        this.updatePaginatedData();
    }

    onPageChange(page: number) {
        this.currentPage = page;
        this.updatePaginatedData();
    }

    selectRow(row: any) {
        this.selectedRow = row;
        this.rowSelected.emit(row);
    }

    updatePaginatedData() {
        this.paginatedData = this.dataSource.slice(
            (this.currentPage - 1) * this.pageSize,
            this.currentPage * this.pageSize,
        );
    }

    ngOnInit(): void {
        if (this.alreadySelectedRow) {
            this.selectedRow = this.alreadySelectedRow;
        }
    }
}
